import React, { useMemo, useState } from "react";
import { CardComp, TableCompData } from "../../../components";
import EmptyTable from "../../../components/Common/EmptyTable";
import TablePagination from "../../../components/Table/Pagination";
import TableSkeletonLoader from "../../../components/Common/TableSkeletonLoader";
import { ExitedMembersHeader } from "../../../utils/TableHeader";
import { useGetExitedMembersQuery } from "../../../store/admin/member-exit";

export default function ExitedMembers() {
  const [page, setPage] = useState(1);
  const { data, isFetching } = useGetExitedMembersQuery({ page, limit: 20 });

  const tableData = useMemo(() => {
    if (!data?.members) return [];
    return data.members;
  }, [data]);

  const pagination = data?.pagination || {};

  return (
    <div className="space-y-4">
      <CardComp cardClassName="rounded-4 border-0 shadow-none">
        <div className="px-3 pb-2 pt-3">
          <h4 className="fw-bold text-black2 mb-1">Exited Members</h4>
          <p className="text-blacklight small mb-3">
            Former members whose exit settlement is complete. Records are retained for audit; they cannot sign in.
          </p>
        </div>
        <TableCompData
          marginBottom={"72px"}
          columns={ExitedMembersHeader()}
          data={tableData}
          progressPending={isFetching}
          progressComponent={<TableSkeletonLoader rows={10} columns={7} />}
          message={
            !isFetching && <EmptyTable Message="No exited members in this branch" />
          }
          cellPadding="12px"
        />
        {!isFetching && tableData?.length > 0 && (
          <TablePagination
            marginTop={"0"}
            handlePageChange={setPage}
            currentPage={pagination.currentPage}
            totalPages={pagination.totalPages}
            total={pagination.total}
            count={pagination.count}
            perPage={pagination.perPage}
          />
        )}
      </CardComp>
    </div>
  );
}
